import { FilterAltOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Popover,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const createdByOptions = [
  { label: "All", value: "all" },
  { label: "Current User", value: "user" },
];

const ProvisionFilter = ({ onChange, services, filtersEnabled }) => {
  const anchorRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState(filtersEnabled);

  useEffect(() => {
    onChange({ ...filters, accounts: filtersEnabled.accounts });
    //eslint-disable-next-line
  }, [filters]);

  const handleFilterChange = (event, filterGroup) => {
    if (filterGroup === "createdBy") {
      setFilters((prevFilters) => ({
        ...prevFilters,
        createdBy: event.target.value,
      }));
    } else {
      const { value, checked } = event.target;
      setFilters((prevFilters) => {
        const updatedFilters = { ...prevFilters };
        if (checked) {
          updatedFilters[filterGroup] = [...updatedFilters[filterGroup], value];
        } else {
          updatedFilters[filterGroup] = updatedFilters[filterGroup].filter(
            (item) => item !== value
          );
        }
        return updatedFilters;
      });
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-textfields" : undefined;

  return (
    <Box>
      <Button
        ref={anchorRef}
        variant="outlined"
        sx={{
          height: "42px",
          marginLeft: "10px",
          borderRadius: "10px",
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Filter
        <FilterAltOutlined />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div style={{ padding: "20px", minWidth: "200px", maxWidth: "500px" }}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography>Filter</Typography>
            <Button
              variant="outlined"
              color="error"
              sx={{
                marginLeft: "10px",
                borderRadius: "12px",
              }}
              onClick={() =>
                setFilters({
                  createdBy: "all",
                  services: [],
                  accounts: filtersEnabled.accounts,
                })
              }
            >
              Reset
            </Button>
          </Box>
          <Divider style={{ margin: "10px 0" }} />
          <FormControl component="fieldset">
            <FormLabel component="legend">Created By</FormLabel>
            <RadioGroup
              name="createdBy"
              value={filters?.createdBy}
              onChange={(e) => handleFilterChange(e, "createdBy")}
              row
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  width: "100%",
                }}
              >
                {createdByOptions.map((option) => (
                  <FormControlLabel
                    value={option?.value}
                    control={<Radio />}
                    label={option.label}
                  />
                ))}
              </Box>
            </RadioGroup>
          </FormControl>
          <Divider style={{ margin: "10px 0" }} />
          <FormControl component="fieldset">
            <FormLabel component="legend">Services</FormLabel>
            <RadioGroup name="services" row>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  width: "100%",
                }}
              >
                {services.map((service) => (
                  <FormControlLabel
                    value={service}
                    control={
                      <Checkbox
                        checked={filters?.services?.includes(service)}
                        value={service}
                        onChange={(e) => handleFilterChange(e, "services")}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            borderRadius: "50% !important",
                          },
                        }}
                      />
                    }
                    label={service}
                  />
                ))}
              </Box>
            </RadioGroup>
          </FormControl>
        </div>
      </Popover>
    </Box>
  );
};

export default ProvisionFilter;
